<template>
    <form class="staged-form">
        <div class="stage-selector-wrapper">
            <div class="stage-selector" :class="{ active: currentStage === index, visited: currentStage > index }" v-for="(stage, index) in stages" @click="changeStage(index)">
                <span class="number">{{ index + 1 }}</span>
                <span class="value">{{ stage.stageSelectorTitle }}</span>
            </div>
        </div>
        <div class="stage-header">
            <p class="stage-subtitle">Step {{ currentStage + 1 }}</p>
            <p class="stage-title">{{ stages[currentStage].title }}</p>
        </div>

        <div v-for="(stage, index) in stages" class="staged-form-content" :key="stages.id" v-show="index === currentStage">
            <slot :name="stage.id"></slot>
        </div>

        <div class="staged-form-actions" :class="{ finalstage: currentStage === stages.length - 1 }">
            <button type="button" class="btn secondary" :class="{ hidden: currentStage === 0 }" @click.prevent="previousStage">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-arrow-left">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                <span class="label">Previous</span>
            </button>
            <button
                v-if="!($store.state.calculatedResults && $store.state.calculatedResults?.exceedsPalletLimit) && !($store.state.calculatedResults && $store.state.calculatedResults?.exceedsDistanceLimit)"
                type="button"
                class="btn primary"
                :class="{ grow: currentStage === stages.length - 1 }"
                @click.prevent="nextStage"
                :disabled="
                    currentStage === stages.length - 1 &&
                    (!$store.getters.deliveryRates ||
                        $store.getters.deliveryRates.length === 0 ||
                        isSending ||
                        ($store.state.calculatedResults && $store.state.calculatedResults?.exceedsDistanceLimit) ||
                        ($store.state.calculatedResults && $store.state.calculatedResults?.exceedsPalletLimit))
                ">
                <span class="label">{{ continueButtonText }}</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-arrow-right">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
            </button>
            <button v-else type="button" class="btn primary" :class="{ grow: currentStage === stages.length - 1 }"
                @click.prevent="redirectToContactForm">
                <span class="label">{{ continueButtonText }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
            </button>
        </div>
    </form>
</template>

<script>
import axios from "axios";

export default {
	name: "staged-form",
	data() {
		return {
			currentStage: 0,
			isValidationEnabled: true,
			isSending: false,
		};
	},
	props: {
		stages: Array,
	},
	computed: {
		continueButtonText: function () {
			if (this.currentStage !== this.stages.length - 1) return "Continue";
			if (this.$store.state.calculatedResults?.exceedsPalletLimit) {
				return "Please contact us directly";
			}
			if (this.$store.state.calculatedResults?.exceedsDistanceLimit) {
				return "Delivery exceeds maximum delivery range. Please contact us directly";
			}
			if (
				!this.$store.getters.deliveryRates ||
				this.$store.getters.deliveryRates.length === 0
			) {
				return "Please contact us directly";
			}
			if (this.currentStage === this.stages.length - 1) {
				if (!this.isSending) return "Request a Formal Quotation";
				return "Sending...";
			}
			return "Continue";
		},
	},
	methods: {
		nextStage() {
			if (this.currentStage === this.stages.length - 1) {
				// End reached
				this.submitData();
				return;
			}

			if (this.currentStage < this.stages.length - 1) this.currentStage++;
		},
		previousStage() {
			if (this.currentStage > 0) this.currentStage--;
		},
		changeStage(index) {
			this.currentStage = index;
		},
		performCalculations() {
			this.$store.dispatch("calculateFinalResults");
			// this.$store.commit('enableCalculatingMode');
			// let idealRate = null;
			// let exceedsLimit = false;

			// if (this.$store.state.contactDetails.receivingType === 'delivery') {
			//     let deliveryRates = this.$store.getters.deliveryRates;
			//     let deliveryDistanceMeters = this.$store.state.deliveryDetails.distance.value;
			//     let deliveryDistanceKilometers = deliveryDistanceMeters * 0.001;

			//     if (deliveryDistanceKilometers <= 250) {
			//         let filteredRates = deliveryRates.filter((rate) => {
			//             return deliveryDistanceKilometers > rate.$gt && deliveryDistanceKilometers <= rate.$lte;
			//         });

			//         idealRate = filteredRates[0];
			//     } else {
			//         idealRate = null;
			//         exceedsLimit = true;
			//     }
			// }

			// let itemCalculations = [];

			// for (const item of this.$store.state.cart) {
			//     let itemCalculator = null;
			//     if (item.quantityType === 'sqm') {
			//         itemCalculator = new ItemCalculator(new SquareMeterCalculationStrategy());
			//     } else if (item.quantityType === 'single') {
			//         itemCalculator = new ItemCalculator(new SingleCalculationStrategy());
			//     } else if (item.quantityType === 'cubic') {
			//         itemCalculator = new ItemCalculator(new CubicCalculationStrategy());
			//     }

			//     const { price_excl_vat, price_incl_vat, price_vat, palettes } = itemCalculator.calculate({
			//         variation: item.variation,
			//         quantity: item.quantity,
			//         quantityType: item.quantityType,
			//         receivingType: this.$store.state.contactDetails.receivingType
			//     });

			//     itemCalculations.push({
			//         name: item.product.name,
			//         variation: item.variation.name,
			//         type: item.type.name,
			//         type_id: item.type.id,
			//         quantity: item.quantity,
			//         quantityType: item.quantityType,
			//         price_excl_vat: price_excl_vat,
			//         price_incl_vat: price_incl_vat,
			//         price_vat: price_vat,
			//         palettes: palettes,
			//         receivingType: this.$store.state.contactDetails.receivingType
			//     });
			// }

			// this.$store.commit('storeCalculatedResults', {
			//     products: itemCalculations,
			//     idealRate: idealRate,
			//     exceedsLimit
			// });

			// this.$store.commit('disableCalculatingMode');
		},
		submitData() {
			this.isSending = true;

			grecaptcha.ready(() => {
				grecaptcha
					.execute("6LeAiC0hAAAAANWECg_C_6NSCf7vnxUhQ6a9U6-E", {
						action: "submit",
					})
					.then((token) => {
						axios({
							method: "POST",
							url: "/wp-json/mvabricks/v1/mail",
							headers: {
								"x-api-key": "c918b0e4-7719-4628-ae35-622a515dc143",
							},
							data: {
							products:          this.$store.state.calculatedResults?.products || [],
							rate:              this.$store.state.calculatedResults.idealRate,
							contactDetails:    this.$store.state.contactDetails,
							deliveryDetails:   this.$store.state.deliveryDetails,
							results:           this.$store.getters.calculationTotalResults,
							recaptcha_token:   token,
							customerType:      this.$store.state.customerType,
							contractorDetails: this.$store.state.contractorDetails,
							},
						})
							.then((response) => {
								if (response.data?.data) {
									this.$notify({
										group: "main",
										text: `${response.data.message} ${response.data.data}`,
										type: "success",
									});
									window.location.replace(
										`${window.location.href.replace(/\/+$/, "")}/thank-you`,
									);
								}
							})
							.catch((error) => {
								if (error.response?.data?.message) {
									this.$notify({
										group: "main",
										text: `[${error.response.data.code}] ${error.response.data.message}. Please contact us directly for an estimation`,
										type: "error",
									});
								} else {
									this.$notify({
										group: "main",
										text: "An unexpected error occurred. Please contact us directly for an estimation",
										type: "error",
									});
								}
							})
							.finally(() => {
								this.isSending = false;
							});
					});
			});
		},
		redirectToContactForm() {
			window.location.href = encodeURI(
				`/contact-us?customer_name=${this.$store.state.contactDetails.name}&customer_email=${this.$store.state.contactDetails.email}&customer_number=${this.$store.state.contactDetails.number}`,
			);
		},
	},
	watch: {
		currentStage: function (newStage, oldStage) {
			if (this.isValidationEnabled) {
				// Stage 0 → 1: customer type must be selected
				if (newStage === 1 && !this.$store.state.customerType) {
					this.$notify({
						group: "main",
						text: "Please select whether you are a Private or Contractor customer to continue",
						type: "error",
					});
					this.currentStage = oldStage;
					document.getElementById("scroll-anchor").scrollIntoView({ behavior: "smooth" });
					return;
				}
				// Stage 1 → 2: cart must have at least one item
				if (
					newStage === 2 &&
					(!this.$store.state.cart || this.$store.state.cart.length === 0)
				) {
					this.$notify({
						group: "main",
						text: "At least one product needs to be added to the quotation to continue",
						type: "error",
					});
					this.currentStage = oldStage;
					document.getElementById("scroll-anchor").scrollIntoView({ behavior: "smooth" });
					return;
				}
			}

			if (newStage === 3) {
				if (!this.$store.state.cart || this.$store.state.cart.length === 0) {
					this.$notify({
						group: "main",
						text: "At least one product needs to be added to the quotation to continue",
						type: "error",
					});
					this.currentStage = 1;
					document.getElementById("scroll-anchor").scrollIntoView({ behavior: "smooth" });
					return;
				}

				if (this.isValidationEnabled) {
					let passedValidation = true;

					if (this.$store.state.honeypot) {
						this.$notify({
							group: "main",
							text: "Suspicious request received, please contact us directly for a quotation",
							type: "error",
						});
						passedValidation = false;
					}

					if (!this.$store.state.contactDetails.name) {
						this.$notify({
							group: "main",
							text: "Your name is required",
							type: "error",
						});
						passedValidation = false;
					}

					if (!this.$store.state.contactDetails.email) {
						this.$notify({
							group: "main",
							text: "Your email is required",
							type: "error",
						});
						passedValidation = false;
					}

					if (
						this.$store.state.contactDetails.receivingType === "delivery" &&
						!this.$store.state.deliveryDetails?.address
					) {
						this.$notify({
							group: "main",
							text: "Your delivery address is required",
							type: "error",
						});
						passedValidation = false;
					}

					if (this.$store.state.customerType === "contractor") {
						const { vatNumber, registrationNumber } = this.$store.state.contractorDetails;
						if (!vatNumber && !registrationNumber) {
							this.$notify({
								group: "main",
								text: "Please provide a VAT Number or Registration Number for contractor accounts",
								type: "error",
							});
							passedValidation = false;
						}
					}

					if (!passedValidation) {
						if (oldStage === 1) {
							this.currentStage = 2;
						} else {
							this.currentStage = oldStage;
						}
						document.getElementById("scroll-anchor").scrollIntoView({
							behavior: "smooth",
						});
						return;
					}
				}

				this.performCalculations();
			}

			document.getElementById("scroll-anchor").scrollIntoView({
				behavior: "smooth",
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.staged-form {
    width: 100%;
    .staged-form-content {
        padding: 40px 0px;
        padding-top: 30px;
    }
    .stage-selector-wrapper {
        display: flex;
        flex-flow: row nowrap;

        @media only screen and (max-width: 768px) {
            flex-flow: row wrap;
        }

        .stage-selector {
            line-height: 40px;
            height: 40px;
            background-color: transparentize(#000000, 0.9);
            flex-basis: 0;
            flex-grow: 1;
            text-align: center;
            font-weight: 700;
            color: $cl-primary;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            @media only screen and (max-width: 768px) {
                width: 100%;
                flex-basis: 100%;
                flex-grow: 1;
            }

            .number {
                background-color: $cl-primary;
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                font-size: 12px;
                font-weight: 700;
                border-radius: 50%;
                margin-right: 6px;
            }

            &.active {
                color: white;
                background-color: $cl-primary;
                .number {
                    background-color: white;
                    color: $cl-primary;
                }
            }

            &.visited {
                background-color: transparentize($cl-primary, 0.85);
            }
        }
    }

    .stage-header {
        position: relative;
        padding-bottom: 20px;
        margin-top: 30px;
        .stage-subtitle,
        .stage-title {
            margin: 0;
            padding: 0;
            text-transform: uppercase;
            text-align: left;
            letter-spacing: 0.5px;
        }

        .stage-subtitle {
            font-weight: 600;
            color: $cl-primary;
            font-size: 16px;
            line-height: 16px;
            margin-bottom: 10px;
        }

        .stage-title {
            font-weight: 700;
            font-size: 24px;
            line-height: 24px;
        }

        &::after {
            width: 80px;
            height: 2px;
            background-color: $cl-primary;
            content: '';
            position: absolute;
            // left: calc(50% - 40px);
            left: 0;
            bottom: 0;
        }
    }
    .staged-form-actions {
        display: flex;
        justify-content: space-between;
        padding: 0 0px 40px 0;
        .btn.grow {
            flex-grow: 1;
            margin-left: 10px;
        }

        @media only screen and (max-width: 768px) {
            &.finalstage {
                display: flex;
                flex-flow: row wrap;
                .btn {
                    width: 100%;
                    margin-bottom: 8px;
                    margin-left: 0 !important;
                }
            }
        }
    }
}
</style>